import { render, staticRenderFns } from "./item-company.vue?vue&type=template&id=8e89b848"
import script from "./item-company.vue?vue&type=script&lang=js"
export * from "./item-company.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports